import styled, { css } from 'styled-components';
import Image from '@components/image';
import { generateScales } from '@helpers/generate-media-queries';
import Text from '@components/text';
import LinkComponent from '@components/link';
import { Link as GatsbyLink } from 'gatsby';

export const StyledGatsbyLink = styled(GatsbyLink)`
  text-decoration: none;
`;

export const Container = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 2rem;
    row-gap: 2rem;
    margin-left: auto;
    margin-right: auto;
    align-items: stretch;

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      column-gap: 1.5rem;
      row-gap: 1.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      grid-template-columns: repeat(1, 1fr);
      row-gap: 1rem;
    }
  `}
`;

export const StyledTitle = styled(Text)`
  ${({ theme }) => css`
    margin: 0 auto;
    max-width: 41rem;
    width: 100%;
    text-align: center;

    ${generateScales('margin-bottom', '1.25rem', '2.5rem', theme)}

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      text-align: left;
    }
  `}
`;

export const CopyBlock = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const TextContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    z-index: 1;
    position: relative;
    padding: 0;
    text-align: left;
    ${generateScales('padding', '1rem', '1.5rem', theme)}
    ${generateScales('padding-top', '0.5rem', '1rem', theme)}
    ${generateScales('padding-bottom', '1rem', '2rem', theme)}

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      text-align: left;
      padding-top: 0.5rem;
    }
  `}
`;

export const ImageContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 1rem;
    height: 4rem;
    width: 4rem;
    overflow: hidden;
    border-radius: 4rem;
    background-color: ${theme.colors.black};
    transition: transform 0.125s ease-in-out;

    ${generateScales('margin-top', '0rem', '-0.375rem', theme)}
  `}
`;

export const StyledImage = styled(Image)`
  height: 1.75rem;
  width: 1.75rem;
  transition: transform 0.125s ease-in-out;
`;

export const StyledLink = styled(LinkComponent)`
  ${({ theme }) => css`
    margin: 0;
    ${generateScales('font-size', theme.fontSize.body.mobile, theme.fontSize.body.desktop, theme)}

    a {
      color: ${theme.colors.white};
      font-family: ${theme.fontFamily.text};
    }
  `}
`;

interface BlockProps {
  hasLink: boolean;
}

export const Block = styled.div<BlockProps>`
  ${({ theme, hasLink = false }) => css`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    cursor: ${hasLink ? 'pointer' : 'default'};
    transition: transform 0.2s ease-in-out;

    &:hover {
      transform: scale(1.03125);

      ${ImageContainer} {
        transform: scale(1.125);
      }

      ${StyledLink} {
        a {
          transition: background-size 0.25s ease-in-out;
          background-size: 100% 0.09375rem;
        }
      }
    }

    background-color: ${theme.backgroundColors.primary};
    border-radius: ${theme.borderRadius.normal};
  `};
`;
